import { OrderSide } from "@cede/types";

export const getFromAndToAmountsFromQuoteAndBase = (quoteAmount: number, baseAmount: number, orderSide: OrderSide) => {
  const fromAmount = orderSide === "buy" ? quoteAmount : baseAmount;
  const toAmount = orderSide === "buy" ? baseAmount : quoteAmount;
  return { fromAmount, toAmount };
};
